// extracted by mini-css-extract-plugin
export var borderRadius = "_4u-4";
export var large = "_4u-3";
export var logoContainer = "_4u-0";
export var nameLogo = "_4u-2";
export var small = "_4u-1";